import React from "react";
import {
  FaUserTie,
  FaBullseye,
  FaHandshake,
  FaLightbulb,
} from "react-icons/fa";

const directors = [
  {
    role: "Chairman",
    name: "KC Akuma",
    image: "/images/KC-Akuma.jpg",
    profileLink: "/board-of-directors/kings-c-akuma",
    bio: "Seasoned energy executive with over 25 years of experience in power sector transformation.",
    color: "bg-gradient-to-br from-green-900 to-black",
  },
  {
    role: "Member",
    name: "Abayomi Adeyemi",
    profileLink: "/board-of-directors/abayomi-Adeyemi",
    image: "/images/Yomi-Profile-pics.jpg",
    bio: "Financial strategist specializing in infrastructure investments and corporate governance.",
    color: "bg-gradient-to-br from-green-700 to-green-900",
  },
  {
    role: "Member",
    name: "Okaima Ohizua",
    image: "/images/okaima.jpeg",
    profileLink: "/board-of-directors/okaima-ohizua",
    bio: "Operations expert with extensive background in utility management and customer service excellence.",
    color: "bg-gradient-to-br from-yellow-400 to-yellow-600",
  },
  {
    role: "Member",
    name: "AYODEJI GBELEYI",
    image: "/images/deji.jpeg",
    profileLink: "/board-of-directors/ayodeji-gbeleyi",
    bio: "Academic leader and policy advisor specializing in energy economics and regulatory frameworks.",
    color: "bg-gradient-to-br from-green-800 to-black",
  },
  {
    role: "Member",
    name: "Osamwonyi Uhunmwangho",
    profileLink: "/board-of-directors/osamwonyi-uhunmwangho",
    image: "/images/osamwonyi.jpeg",
    bio: "Renowned engineer and sustainability advocate with focus on renewable energy integration.",
    color: "bg-gradient-to-br from-yellow-500 to-black",
  },
  {
    role: "Member",
    name: "Jonathan Lawani",
    profileLink: "/board-of-directors/engr-jonathan-lawani/",
    image: "/images/Lawani.png",
    bio: "Renowned engineer and sustainability advocate with focus on renewable energy integration.",
    color: "bg-gradient-to-br from-yellow-500 to-black",
  },
];

const BoardOfDirectors = () => {
  return (
    <div className="w-full min-h-screen bg-white">
      <div className="bg-white py-6">
        <div className="container mx-auto px-4 md:px-16">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-1 bg-yellow-400 rounded-full"></div>

                <h2 className="text-xs font-bold text-green-700 uppercase tracking-widest">
                  Governance
                </h2>
              </div>

              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black mb-6 uppercase leading-tight">
                Strategic <span className="text-green-700">Leadership</span> and
                Governance
              </h2>

              <div className="space-y-4">
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-normal">
                  The Board of Directors of BEDC Electricity Plc provides strategic leadership, governance
                  oversight, and policy direction to ensure the delivery of
                  safe, reliable, and sustainable electricity services across
                  our franchise areas.
                </p>

                <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-normal">
                  Comprising seasoned professionals with deep expertise across
                  the energy, finance, and corporate governance sectors, the
                  Board plays a critical role in shaping BEDC's long-term
                  vision, driving operational excellence, and upholding the
                  highest standards of accountability and transparency.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {[
                {
                  icon: <FaBullseye />,
                  title: "Strategic Vision",
                  color:
                    "bg-green-50 text-green-700 border-green-100",
                },
                {
                  icon: <FaHandshake />,
                  title: "Stakeholder Value",
                  color:
                    "bg-yellow-50 text-yellow-700 border-yellow-100",
                },
                {
                  icon: <FaUserTie />,
                  title: "Leadership",
                  color:
                    "bg-gray-50 text-black border-gray-100",
                },
                {
                  icon: <FaLightbulb />,
                  title: "Innovation",
                  color:
                    "bg-green-900 text-white border-green-800",
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className={`${item.color} p-6 rounded-2xl shadow-sm border text-center transition-transform hover:-translate-y-1`}
                >
                  <div className="text-2xl mb-3 flex justify-center">
                    {item.icon}
                  </div>

                  <h4 className="font-bold uppercase text-xs tracking-tight">
                    {item.title}
                  </h4>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

      {/* Board Members Section */}
      <div className="py-8 bg-gray-50">
        <div className="container mx-auto px-2 md:px-10">
          
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black mb-3 uppercase">
              MEET OUR <span className="text-green-700">LEADERS</span>
            </h2>

            <div className="w-20 h-1.5 bg-yellow-400 mx-auto rounded-full mb-2"></div>

            <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto font-normal">
              Experienced professionals guiding BEDC towards excellence in
              electricity distribution
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {directors.map((director, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col"
              >
                {/* Fixed height applied to the wrapper container */}
                <div className="relative w-full h-82 overflow-hidden">
                  <img
                    src={director.image}
                    alt={director.name}
                    className="w-full h-full object-cover object-top transform transition-transform duration-500 group-hover:scale-105"
                  />

                  <div
                    className={`absolute top-4 right-4 px-3 py-1 rounded-full text-[10px] font-bold uppercase text-white ${director.color}`}
                  >
                    {director.role}
                  </div>
                </div>

                <div className="p-6">
                    <h3 className="text-lg md:text-xl font-bold text-black group-hover/link:text-green-700 transition-colors uppercase tracking-tight">
                      {director.name}
                    </h3>
               

                  <div className="mt-3 flex items-center gap-2 text-yellow-600 font-bold text-xs uppercase tracking-wider">
                  <a href={director.profileLink} className="block group/link">
                    View Profile <span>→</span>
                  </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* Closing Statement */}
      <div className="bg-yellow-400 py-10">
        <div className="container mx-auto px-4 md:px-16 max-w-5xl">
          
          <div className="text-center">
            <div className="inline-block p-3 bg-black rounded-full mb-6">
              <FaHandshake className="text-2xl text-yellow-400" />
            </div>

            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black mb-4 uppercase tracking-tight">
            Driving impact across our community            </h3>

            <p className="text-sm sm:text-base text-black leading-relaxed mb-6 font-semibold opacity-90">
              Through strong governance practices and a commitment to stakeholder
              value, the Board ensures that BEDC remains aligned with national
              power sector reforms while delivering measurable impact to
              customers, partners, and host communities.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default BoardOfDirectors;